/**
 * Enum for storing the different DI implementations that could exist.
 */
export var DependencyToken;
(function (DependencyToken) {
    DependencyToken["EventBus"] = "EventBus";
    DependencyToken["EventProducer"] = "EventProducer";
    DependencyToken["VideoPlayer"] = "VideoPlayer";
})(DependencyToken || (DependencyToken = {}));
export default DependencyToken;
//# sourceMappingURL=DependencyToken.js.map